import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ISelectData } from '@shared/types';

export const selectReducer = createFeatureSelector<ISelectData>('select');

export const selectSelectedData = createSelector(selectReducer, (state) => state);
